/**
 * Tool Display 消息处理器
 */
import { mapRawToSearchDocs } from '../../mappers';
import type { StreamMessageHandler, StreamMessageData, HandlerContext } from '../types';

/**
 * Tool Display 消息处理器
 * 处理 business_type='tool_display' 的消息，展示右侧面板
 */
export const toolDisplayHandler: StreamMessageHandler = {
  name: 'tool-display',

  canHandle(data: StreamMessageData): boolean {
    return data.business_type === 'tool_display';
  },

  handle(data: StreamMessageData, ctx: HandlerContext): boolean {
    const { tool_key, streaming_content, content } = data;
     // 处理 search_json_docs 特殊逻辑
    if (tool_key === 'search_json_docs' && Array.isArray(content)) {
      ctx.streamContext.deps.searchDocsList.value = mapRawToSearchDocs(content);
    }

    ctx.messageUpdater.updateStreamingToolDisplay(tool_key, streaming_content ?? '');

    // tool_display completed 时不再结束流，等待 SSE 连接关闭
    return false;
  },
};
